import React from 'react'
import HeroSection from './HeroSection'
import { Box } from '@mui/system'
import PremiumSalesSection from './PremiumSalesSection'
import Philosophy from './Philosophy'
import WhatWeDeliver from './WhatWeDeliver'
import Services from './Services'
import Exhibits from './Exhibits'
import TestimonialsQR from '../Resume/RecommendationCTA'
import Testimonials from './Testimonials'
import YouTube from './YouTube'
import Blogs from './Blogs'


const index = () => {
  return (
    <Box
      sx={{
    minHeight: "100vh",

    // 🔥 SINGLE GLOBAL BACKGROUND
    backgroundImage: `
      linear-gradient(180deg, rgba(15, 99, 165, 0.7) 0%, rgba(10, 22, 40, 0.85) 50%, rgba(5, 10, 20, 0.95) 100%),
      url('https://d2xsxph8kpxj0f.cloudfront.net/310519663339310732/Lh6NwvwdfYtSXaGvaRDDwV/hyderabad-night-skyline-DaiCBTeohHDoMEGb8Gz2uK.webp')
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",

    // Important
    backgroundRepeat: "no-repeat",
  }}
    >
        <HeroSection/>
        <PremiumSalesSection/>
        <Philosophy/>
        <WhatWeDeliver/>
        <Services/>
        <Exhibits/>
        <Testimonials/>
        <YouTube/>
        <Blogs/>
    </Box>
  )
}

export default index